import {DefaultRootState, useSelector} from 'react-redux';
import {useFilter} from './filter';
import {DependencyList} from 'react';

export function useFilterSelector<TState = DefaultRootState, TSelected = unknown>(selector: (state: TState) => TSelected[], predicate: (item: TSelected) => boolean, deps?: DependencyList) {
    return useFilter(useSelector(selector), predicate, deps);
}
